import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * Logs a conversation/interaction on behalf of a buyer agent, bypassing the
 * LLM entirely. Returns `{ simulationId, agentConversationId, dealId,
 * interactionId, channelEntryId }` on success — every id confirms a
 * downstream write actually landed (the real DealInteraction, the
 * conversation-channel entry the seller's next tick discovers, and the
 * buyer's own message history).
 */
const manualBuyerAction = (
  simulationId,
  agentConversationId,
  payload,
  callback,
  errorCallback,
) => {
  return async (dispatch) => {
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.post(
            `/ads/admin/simulations/${simulationId}/agents/${agentConversationId}/manual-buyer-action`,
            payload,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            if (typeof callback === 'function') callback(response?.data);
          } else {
            if (typeof errorCallback === 'function')
              errorCallback('Failed to log the manual buyer action');
          }
        } catch (e) {
          if (typeof errorCallback === 'function')
            errorCallback(
              e?.response?.data?.message ||
                'Failed to log the manual buyer action',
            );
        }
        unsubscribe();
      });
    } catch (e) {
      if (typeof errorCallback === 'function')
        errorCallback('Failed to log the manual buyer action');
    }
  };
};

export default manualBuyerAction;
